import forOwn from 'mout/object/forOwn'
import sortByPropText from './sortByPropText'

export default function sortItemsBySequence (activeSet, itemsInSet) {

  let setContentArray = []
  forOwn(activeSet.content, (val, key, o) => {
    if (val.active) {
      setContentArray.push({
        ...val,
        id: key,
      })
    }
  })

  // Create a sequenced array from activeSet content
  let sortedSetContentArray = sortByPropText(setContentArray, 'index')
  // Get just id's
  let sortedSetContentIds = sortedSetContentArray.map((content) => {
    return content.id
  })

  // build the final itemsInSet based on the ids in sortedSetContentIds

  let sortedItemsInSet = []
  sortedSetContentIds.forEach((id) => {
    itemsInSet.forEach((item) => {
      if (item.itemId) {
        if (id === item.itemId) {
          sortedItemsInSet.push(item)
        }
      } else if (item.id) {
        if (id === item.id) {
          sortedItemsInSet.push(item)
        }
      }
    })
  })
  return sortedItemsInSet
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/sortItemsBySequence.js